module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="listerregularisation-customBar">\r\n  <div>\r\n    <a class="tableSimple" href="javascript:void(0)" style="text-decoration: none; padding: 2px;">\r\n      '+
((__t=(i18n.t('common:listerregularisations.simple')))==null?'':__t)+
'\r\n    </a>\r\n  </div>\r\n  <div>\r\n    <a class="tableDetaille" href="javascript:void(0)" style="text-decoration: none; padding: 2px;">\r\n      '+
((__t=(i18n.t('common:listerregularisations.detaille')))==null?'':__t)+
'\r\n    </a>\r\n  </div><br/>\r\n</div><br/>\r\n';
}
return __p;
};
